/* eslint-disable no-console */
import wrapper from 'wrapper';
import 'core-js/es6/object';
import 'core-js/es6/array';
import 'core-js/es7/object';
import 'core-js/es7/array';
import facewallConfig from './facewall-config';
import Modal from './components/modal/modal';
import Filters from './components/filters/filters';
import './components/back-to-top-button/back-to-top-button';
import lazyLoadImages from './lazy-load';

const mainContent = wrapper.select('#democrats-candidates-app');
const cardImages = wrapper.selectAll('.lazy.card__portrait');
const cardsListNode = wrapper.select('.cards__list');
const cardNodes = cardsListNode.querySelectorAll('.card');
const firstParagraphs = wrapper.selectAll('.first_paragraph');
const isShadowDom = wrapper.select('.bbc-news-vj-shadow-dom');
const isAmp = wrapper.select('.bbc-news-vj-wrapper--amp');
const backToTopButton = wrapper.select('.facewall-back-to-top-button');
const allAges = calculateAllAges();
let currentCardIndex;

const filters = new Filters();
const modal = new Modal(filters, allAges);

enhanceContent();
lazyLoadImages();

function enhanceContent() {
    if (mainContent.classList.contains('core-content')) {
        mainContent.classList.remove('core-content');
        backToTopButton.removeAttribute('style');
        wrapper.select('.facewall-filters-container').style.display = 'block';
        mainContent.classList.add('enhanced');
        Array.from(cardImages).forEach(cardImage => {
            const img = cardImage;
            img.style.display = 'block';
        });

        if (!isShadowDom) {
            mainContent.classList.add('enhanced--iframed');
        }
    }

    Array.from(firstParagraphs).forEach(firstParagraph => {
        firstParagraph.classList.add('show');
    });

    enhanceCardsList();
}

function enhanceCardsList() {
    setNumberOfColumns();
    setAllAges();

    Array.from(cardNodes).forEach((articleNode, i) => {
        articleNode.setAttribute(
            'aria-label',
            `${getFullNameFromCard(articleNode.getAttribute('data-id'))}, ${__('card_1_button_text')}`,
        );
        articleNode.setAttribute('role', 'button');
        articleNode.setAttribute('tabindex', 0);

        articleNode.addEventListener('click', e => {
            currentCardIndex = articleNode.getAttribute('data-id');
            articleNode.scrollIntoView(true);
            modal.createModal(calculatePosition(e), currentCardIndex, isAmp);
        });

        articleNode.addEventListener('keypress', e => {
            if (e.code === 'Space' || e.code === 'Enter') {
                e.preventDefault();
                currentCardIndex = articleNode.getAttribute('data-id');
                articleNode.scrollIntoView(true);
                modal.createModal(calculatePosition(e), currentCardIndex, isAmp);
            }
        });
    });
}

function calculatePosition(e) {
    const target = e.currentTarget || e.target;
    let scrollPosition = facewallConfig.grid.modalOffset * 2;
    if (wrapper.getScrollPosition() >= scrollPosition) scrollPosition = wrapper.getScrollPosition();
    const boundingClientRectTop = calculateBoundingClientRectTop(target, scrollPosition);
    return isShadowDom ? scrollPosition : boundingClientRectTop;
}

// Fixes positioning of the modal for amp
function calculateBoundingClientRectTop(target, scrollPosition) {
    if (isAmp) {
        if (target.getBoundingClientRect().top === 0) return scrollPosition - facewallConfig.grid.ampModalOffset;
        // only the first time a card is clicked
        // the bounding client rect returns zero and
        // the scrollPosition returns the number that's close to what we need
        return target.getBoundingClientRect().top - facewallConfig.grid.ampModalOffset;
        // in both places we subtract 430 px (facewallConfig.grid.ampModalOffset)
        // to adjust the position because in amp, the modal-container's position
        // is changed from fixed (in iframe and shadowdom) to absolute (only in amp)
    }
    return target.getBoundingClientRect().top + facewallConfig.grid.modalOffset;
}

function setNumberOfColumns() {
    const listWidth = cardsListNode.parentElement.clientWidth;
    for (let i = 0; i < facewallConfig.grid.breakPoints.length; i++) {
        if (listWidth >= facewallConfig.grid.breakPoints[i].w) {
            cardsListNode.className = 'cards__list';
            cardsListNode.classList.add(facewallConfig.grid.breakPoints[i].className);
            break;
        }
    }
}

function getFullNameFromCard(id) {
    return `${__(`card_${id}_firstname`)} ${__(`card_${id}_secondname`)}`;
}

function setAllAges() {
    Array.from(cardNodes).forEach(card => {
        const dateEl = card.querySelector('.card__header__strapline__date');
        const age = calculateAgeFromDob(card.getAttribute('data-id'));
        dateEl.textContent = age ? `${__('pop-out_1_age_text')} ${age}` : '';
    });
}

function calculateAllAges() {
    const ages = {};
    Array.from(cardNodes).forEach((node, i) => {
        ages[`person_${i + 1}`] = calculateAgeFromDob(i + 1);
    });
    return ages;
}

function calculateAgeFromDob(cardId) {
    const dob = new Date(`${__(`card_${cardId}_date`)}`);
    const todayDate = new Date();
    let age = todayDate.getFullYear() - dob.getFullYear();
    const month = todayDate.getMonth() - dob.getMonth();
    if (month < 0 || (month === 0 && todayDate.getDate() < dob.getDate())) {
        age -= 1;
    }
    return age;
}

// From https://codeburst.io/throttling-and-debouncing-in-javascript-646d076d0a44
function debounce(delay, fn) {
    let timerId;
    return function (...args) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            fn(...args);
            timerId = null;
        }, delay);
    };
}

window.addEventListener('resize', () => {
    debounce(100, setNumberOfColumns());
});

wrapper.markPageAsLoaded();
